import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedLocations: [],
};

const locationsSlice = createSlice({
	name: 'reportService',
	initialState: initialState,
	reducers: {
		setLocations: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setLocations, reset } = locationsSlice.actions;

export default locationsSlice.reducer;